import React, { useEffect, useState } from "react";

export default function VisitorCounter() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Get current count from localStorage (or 0)
    let currentCount = parseInt(localStorage.getItem("visitorCount")) || 0;

    // Increment by 1 for new visitor
    currentCount += 1;
    localStorage.setItem("visitorCount", currentCount);

    setCount(currentCount);
  }, []);

  return (
    <div className="text-white/85 text-sm mt-1">
      {count.toString().padStart(6, "0")}
    </div>
  );
}
